<template>
  <div class="left-menu">
    <ul id="vertical-multilevel-menu">
      <template v-for="(item, index) in items">
        <template v-if="item.items && item.items.length">
          <li :key="index">
            <a
              @click.prevent="toggle(item.id)"
              href="#"
              active-class="selected"
              >{{ item.name }}</a
            >
          </li>
          <v-slide-y-transition>
            <div v-if="models[item.id]">
              <ul
                v-for="(itm, indx) in item.items"
                :key="'sub-' + indx"
                class="root-item"
              >
                <li>
                  <router-link :to="itm.to" active-class="selected">{{
                    itm.name
                  }}</router-link>
                </li>
              </ul>
            </div>
          </v-slide-y-transition>
        </template>
        <template v-else>
          <li :key="index">
            <router-link :to="item.to" active-class="selected">{{
              item.name
            }}</router-link>
          </li>
        </template>
      </template>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  mounted() {
    this.openIfSub();
  },
  data() {
    return {
      models: {},
    };
  },
  props: {
    items: {
      type: [Array, Object],
      default: function() {
        return {};
      },
    },
  },
  methods: {
    toggle(id) {
      if (!this.models[id]) {
        Vue.set(this.models, id, true);
      } else {
        this.models[id] = false;
      }
    },
    openIfSub() {
      const pId = this.$route.params.pGroupId;
      if (pId) {
        Vue.set(this.models, pId, true);
      }
    },
  },
};
</script>

<style lang="scss">
.left-menu {
  #vertical-multilevel-menu {
    li > a.selected {
      color: red;
    }
  }
}
</style>
